// extracted by mini-css-extract-plugin
export default {"keyWrapper":"api_keyWrapper__oujEC","keyDisplay":"api_keyDisplay__rW1MW"};